import PropTypes from "prop-types";
import ArrowRightWhite from "/public/images/icons/arrowRightWhite.svg?react";
import { format, parse } from 'date-fns';
import { Link } from "react-router-dom";

export default function ParticipantCard({ participant, href, location }) {
    const gradient =  
    participant.BandColour === "RED"
        ? "#A4123F"
      : participant.BandColour === "BLUE"
        ? "#1877D3"
      : participant.BandColour === "GREY"
        ? "#727272"
      : participant.BandColour === "BLACK"
        ? "#101820"
      : participant.BandColour === "YELLOW"
        ? "#EAAA00"
      : "#F8F8F8";

    return (
      <Link
        to={href}
        state={{ participant: participant }}
      >
        <div
          className={`border-[1px] border-[#E3E3E3] rounded-[4px] mr-5`}
          style={{
            background: `${gradient}`,
          }}
        >
          <div
            className={`flex flex-col px-6 h-full rounded-[4px] py-5`}
            style={{
              background: `linear-gradient(151.5deg, rgba(255,255,255, 0.1) 0%, rgba(255,255,255, 0.1) 50%, ${gradient} 50.1%, ${gradient} 100%)`,
            }}
          >
            <div className="flex h-full justify-between">
              <div
                className={`flex flex-col gap-y-0 justify-center z-10 basis-[202px]`}
              >
                {participant?.ProfilePicture ? (
                  <img src={participant?.ProfilePicture + `?t=${Date.now()}`} width="40" height="40" alt="avatar" className="mb-3 rounded-full object-cover w-10 h-10" />
                ) : (
                  <img
                    src="/images/default-avatar.svg"
                    width="40"
                    height="40"
                    alt="default avatar"
                    className="mb-3"
                  />
                )}
                
                <p className={`text-base font-medium leading-[26px] text-white ${location !== "profile" && "mb-3"}`}>
                  {participant?.ParticipantName}{location !== "profile" && "'s Profile"}
                </p>

                {location === "profile" && (
                  <p className='text-[14px] leading-[24px] text-white mb-3'>Last Updated • {participant?.LastUpdated ? format(new Date(participant.LastUpdated), 'dd/MM/yyyy') : ''}</p>
                )}

                {participant?.TransferPending ? (
                  <p className="hover:select-none text-[12px] color-[#1E1E1E] leading-6 bg-white rounded-[4px] pl-[11.8px] pr-[9.5px] tracking-[2.4px] uppercase font-semibold self-start w-fit">
                    Transferring
                  </p>
                ) : (
                  <p className={`
                    hover:select-none text-[11px] color-[#1E1E1E] leading-6 bg-white rounded-[4px] pl-[9px] pr-[6.5px] tracking-[2px] uppercase font-semibold self-start w-fit
                  `}>
                    {participant.ProfileActivated === 0 ? (
                      "NOT ACTIVATED"
                    ) : ((participant.ProfileActivated === 1 && participant?.CurrentActivityCount > 0)) ? (
                      "ACTIVITY IN PROGRESS"
                    ) : (
                      null
                    )}
                  </p>
                )}
              </div>

              <div className="flex flex-col items-end h-full justify-end">
                <img
                  src={participant?.BandImageURL}
                  alt="band"
                  className="max-w-[175px] mr-[-48px]"
                />

                {location !== "profile" && (
                  <ArrowRightWhite className="mt-[-10px]" />
                )}
              </div>
            </div>
          </div>
        </div>
      </Link>
    );
}

ParticipantCard.propTypes = {
  participant: PropTypes.object,
  href: PropTypes.string,
  location: PropTypes.string,
};
